'use client'

import { useDocumentEventOutside } from '@/hooks/browser/useDocumentEventOutside'
import { RefObject } from 'react'

export function usePointerDownOutside<ElementType extends Element>(
  containerRef: RefObject<ElementType>,
  listener: (event: PointerEvent) => unknown
) {
  useDocumentEventOutside('pointerdown', containerRef, listener)
}
